const liveMenuItemsArray: LiveMenuItems[] = [
  'live-dice',
  'live-poker',
  'live-game-shows',
  'live-roulette',
  'live-blackjack',
  'live-baccarat',
];

const getLiveMenuItem = (optionValue: string): optionValue is LiveMenuItems =>
  liveMenuItemsArray.includes(optionValue as LiveMenuItems);

const getFilteredOptions = (
  pathname: string | null,
  options: FilterOption[],
  type: FilterSection,
) => {
  if (pathname?.includes('/categories/live-casino') && type === 'categories') {
    return options.filter((option) => getLiveMenuItem(option.value));
  }
  return options;
};

export default getFilteredOptions;
